/**
 * For "scmp.js?profile=true&useDebugMode=false" function returns
 * {profile: "true", useDebugMode: "false"}
 * @return {Object|null}
 */
const getScriptParams = () => {
  const scripts = document.querySelectorAll('script') || [];
  const scmpScript = Array.from(scripts).find(({src}) => {
    return !!~src.indexOf('scmp.js?') || !!~src.indexOf('scmp-external.js?');
  });

  if (scmpScript) {
    const params = scmpScript.src
      .split('?')
      .pop()
      .split('&');
    const paramsObj = {};

    params.forEach(param => {
      const [key, value] = param.split('=');

      paramsObj[key] = value;
    });
    return paramsObj;
  } else {
    return {};
  }
};

let profilePage = null;
/**
 * Returns true if script is used on Profile page.
 * @return {boolean}
 */
export const inProfile = () => {
  if (profilePage === null) {
    const {profile} = getScriptParams();

    profilePage = profile === 'true';
  }

  return profilePage;
};

/**
 * Returns true if script should be automatically opened.
 * @return {boolean}
 */
export const autoOpen = () => {
  const {auto_open: open} = getScriptParams();
  return open !== 'false';
};
